import { axiosInstance } from '../axios/axiosHandler';
import { EndPoints } from '../axios/endPoints';
import { authHeader } from '../store/auth-slice/auth-slice';
import { UserProfileModel } from '../types/profile.types';

type ApiEnvelope<T> = {
    result?: T;
};

export async function getUserProfileInfo(): Promise<UserProfileModel> {
    const response = await axiosInstance.get<ApiEnvelope<UserProfileModel>>(
        EndPoints.GET_USER_PROFILE_INFO,
        authHeader()
    );

    return response.data?.result ?? (response.data as unknown as UserProfileModel);
}

export async function updatePreferredLanguage(languageCode: string): Promise<void> {
    await axiosInstance.post(
        EndPoints.UPDATE_PREFERRED_LANGUAGE,
        JSON.stringify(languageCode),
        { ...authHeader(), headers: { ...authHeader().headers, 'Content-Type': 'application/json' } }
    );
}
